import { DotLottieReact } from '@lottiefiles/dotlottie-react'
import { Button } from '@/components/ui/button'
import { Dialog, DialogContent } from '@/components/ui/dialog'
import tickAnimationUrl from '@/assets/tick mark animtion.lottie?url'

interface FirstTripReadyDialogProps {
  isOpen: boolean
  onClose: () => void
  onGoToDashboard: () => void
}

export function FirstTripReadyDialog({
  isOpen,
  onClose,
  onGoToDashboard,
}: FirstTripReadyDialogProps) {
  return (
    <Dialog open={isOpen} onOpenChange={(open) => !open && onClose()}>
      <DialogContent className="bg-surface-L0 rounded-lg border border-border-L2 shadow-lg p-8 max-w-[320px] gap-2">
        <div className="flex flex-col items-center gap-4">
          <DotLottieReact
            src={tickAnimationUrl}
            autoplay
            loop={false}
            style={{ width: 44, height: 44 }}
          />
          <p className="text-lg font-bold text-content-primary-bold text-center tracking-[-1px] w-full leading-7">
            Your first trip is ready.
          </p>
          <p className="text-sm text-content-primary-subtle text-center w-full leading-5">
            Add more trips, manage crew, and run your operations from one place.
          </p>
          <Button
            onClick={onGoToDashboard}
            variant="primary"
            className="w-full bg-background-brand-bold text-background"
          >
            Go to Operations
          </Button>
        </div>
      </DialogContent>
    </Dialog>
  )
}
